import i18next from 'i18next';
import AbstractAppError from '../../../errors/AbstractAppError';

export default class RequestNotFoundError extends AbstractAppError {
  constructor(id: string) {
    super('REQUEST_NOT_FOUND', i18next.t('errors.requestNotFound', { ns: 'bed-management', id }));
  }
}
